<template>
  <span class="add-one animate__animated animate__backInUp"
    >+{{ addnumber }}</span
  >
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    computed: {
      ...mapState(['rankingActivityInfo']),
      addnumber() {
        const { extraInfo = {} } = this.rankingActivityInfo || {}
        const { giveLike = 1 } = extraInfo
        return 1 / giveLike
      },
    },
  }
</script>
<style scoped lang="scss">
  .add-one {
    position: absolute;
    bottom: 0;
    left: 40%;
    color: red;
    font-size: 36px;
  }
  .animate__animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
  .animate__backInUp {
    -webkit-animation-name: backInUp;
    animation-name: backInUp;
  }
  @keyframes backInUp {
    0% {
      transform: translateY(0px);
      opacity: 0;
    }
    80% {
      transform: translateY(-40px);
      opacity: 1;
    }
    100% {
      transform: translateY(-40px);
      opacity: 0;
    }
  }
</style>
